module.exports = __webpack_public_path__ + "static/media/Inertia_theory_q2.48ee819a.mp4";